module.exports = __webpack_public_path__ + "img/14-twoImg.45d05225.png";